import { c as _c } from "react/compiler-runtime";
import { ErrorComponent } from '@/components';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useEntityDeviceInsights from '../../../../hooks/use-entity-device-insights';
import Content from './components/content';
type DeviceInsightsProps = WithEntityProps & {
  asOf?: string;
};
const DeviceInsights = t0 => {
  const $ = _c(9);
  const {
    entity,
    asOf
  } = t0;
  const {
    error,
    data,
    isSuccess
  } = useEntityDeviceInsights(entity.id, asOf);
  let t1;
  if ($[0] !== error) {
    t1 = error && <ErrorComponent error={error} />;
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data || $[3] !== entity || $[4] !== isSuccess) {
    t2 = isSuccess && <Content entity={entity} events={data.data} />;
    $[2] = data;
    $[3] = entity;
    $[4] = isSuccess;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default DeviceInsights;